import styled from "styled-components";

export const Container = styled.div`
background-color: #f5f5f5;
  height: 100vh;
  position: fixed;
  width: 100vw;
  display: flex;
  flex-direction: column;
`;

// The shell is a fixed 100vh box, so the page area has to be what is left below
// the header. Sizing it 100vh instead pushed its last ~70px (a table's bottom
// horizontal scrollbar, for one) past the bottom of the screen with no way to
// scroll to it.
export const SubContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
`
